<template>
  <div class="MonthlyIOListWeb">
    <v-simple-table dense fixed-header v-if="list.length > 0">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="">{{ $t("DayName") }}</th>
            <th class="">{{ $t("EntryDate") }}</th>
            <th class="">{{ $t("EntryTime") }}</th>
            <th class="">{{ $t("ExitTime") }}</th>
            <th class="">{{ $t("ExitDate") }}</th>
            <th class="">{{ $t("DurationTime") }}</th>
            <th class=""></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in list"
            :key="index"
            :class="[rowClasses(item), 'text-color-black']"
            @contextmenu.stop="show($event,item)"
          >
            <td>{{ item.EnterDayName }}</td>
            <td>{{ item.BeginDate }}</td>
            <td>{{ item.BeginTime }}</td>
            <td>{{ item.EndTime }}</td>
            <td>{{ item.EndDate }}</td>
            <td :class="item.Duration == '۰۰۰:۰۰' ? 'error--text' : ''">
              {{ item.Duration }}
            </td>
            <td>
              <v-tooltip bottom v-if="item.Vacation == 'True'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="vacation" v-bind="attrs" v-on="on">
                    mdi-calendar-weekend
                  </v-icon>
                </template>
                <span>{{ $t("flagVacation") }}</span>
              </v-tooltip>

              <v-tooltip bottom v-if="item.Mission == 'True'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="mission" v-bind="attrs" v-on="on">
                    mdi-bag-checked
                  </v-icon>
                </template>
                <span>{{ $t("flagMission") }}</span>
              </v-tooltip>

              <v-tooltip bottom v-if="item.Io == 'True'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="io" v-bind="attrs" v-on="on">
                    mdi-sort-clock-ascending-outline
                  </v-icon>
                </template>
                <span>{{ $t("flagKasrkar") }}</span>
              </v-tooltip>

              <v-tooltip bottom v-if="item.ExtraWork == 'True'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="extrawork" v-bind="attrs" v-on="on"
                    >mdi-sort-clock-descending-outline
                  </v-icon>
                </template>
                <span>{{ $t("flagExtraWork") }}</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <IOContextMenu ref="IOContextMenu" :x="x" :y="y" />
  </div>
</template>

<script>
import IOContextMenu from "../../widget/IOContextMenu.vue";
export default {
  components: { IOContextMenu },
  props: {
    list: Array,
  },
  data() {
    return {
      x: 0,
      y: 0,
    };
  },
  methods: {
    show(e,item) {
      //debugger
      e.preventDefault();
      this.$refs.IOContextMenu.hideMenu();
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.$refs.IOContextMenu.showMenu(item);
      });
    },
    rowClasses(item) {
      if (item.DMP == 1) {
        return "bg-green";
      }
    },
  },
};
</script>

<style>
</style>